// exported for testing
export var directionToDegrees = {
  left: 90,
  right: 270,
  up: 180
};
export var getPointingTransform = function getPointingTransform(direction) {
  if (!direction || direction === 'down') {
    return '';
  } // covers the ThumbIcon case of needing to "flip" rather than rotate, while also working for Arrow/Chevron


  if (direction === 'up') {
    return 'transform: scaleY(-1);';
  }

  return "transform: rotate(".concat(directionToDegrees[direction], "deg);");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icon/utils.js
// module id = 729
// module chunks = 12